import React from "react"
import cx from "classnames"
import { PageHeaderTabLink } from "../page-header/page-header-tab-link"
import type { PageHeaderTabLinkProps } from "../page-header/page-header-tab-link"

// =============================================================================
// Props
// =============================================================================

export type PageSecondaryHeaderTabLinkProps = PageHeaderTabLinkProps

// =============================================================================
// Component
// =============================================================================

/**
 * Secondary page header tab link.
 *
 * Renders an `<a>` element with `aria-current="page"` when active. Active when
 * `currentPath` starts with `href`.
 *
 * Must be a descendant of `PageSecondaryHeader.TabLinks`.
 *
 * Accepts a `render` prop to swap in your own link component (e.g. Inertia
 * `Link`, react-router `Link`, plain `<a>`).
 */
export function PageSecondaryHeaderTabLink({
  className,
  ...rest
}: PageSecondaryHeaderTabLinkProps) {
  return <PageHeaderTabLink {...rest} className={cx("py-5", className)} />
}
